export function formatToTwoDecimalPlaces(value: any) {
    const roundedValue = Number(value).toFixed(2);
    const parts = roundedValue.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.') === "NaN" ? "--" : parts.join('.');
  }